/**
 * Build chart data for Discount Amount by Time of Day (Hourly).
 */
export function getTimeOfDayDiscountChartData(
  discountAmountsPerHour,
  startHour = 5,
) {
  const labels = Array.from({ length: 24 }, (_, i) => {
    const hour = (startHour + i) % 24;
    return `${hour}:00`;
  });

  return { labels, discountData: discountAmountsPerHour };
}

/**
 * Build Highcharts options for Discount Amount by Time of Day (areaspline).
 */
export function getTimeOfDayDiscountChartOptions({ labels, discountData }) {
  return {
    chart: { type: "areaspline" },
    title: { text: null },
    xAxis: {
      categories: labels,
      crosshair: true,
      title: { text: "Time of Day" },
    },
    yAxis: {
      min: 0,
      title: { text: "Discount Amount (PHP)" },
      labels: {
        formatter() {
          return "\u20B1" + this.value.toLocaleString();
        },
      },
    },
    tooltip: {
      valuePrefix: "\u20B1",
      valueDecimals: 2,
    },
    plotOptions: {
      areaspline: {
        fillOpacity: 0.3,
        marker: { enabled: false },
      },
    },
    series: [
      {
        name: "Discount Amount",
        data: discountData,
        color: "#ff6384",
      },
    ],
    credits: { enabled: false },
  };
}
